import { Observable, Subject } from 'rxjs';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { StorageServices } from './storageService';
import { BodegaServices } from './bodegaServices';

@Injectable()
export class ConfigServices{
  public static localConfig:any={};
  private setEtiquetaConfig: Subject<any>=new Subject<any>();
  onEtiquetaConfigSetted():Observable<any>{
    return this.setEtiquetaConfig.asObservable();
  }
  constructor(private storageService:StorageServices){}
  public setEtiquetaConf(localConfig, ancho:number, alto:number, left:number, top:number){
    if(!localConfig)
      localConfig={};
    localConfig.etiqueta={};
    localConfig.etiqueta.ancho=ancho;
    localConfig.etiqueta.alto=alto;
    localConfig.etiqueta.left=left;
    localConfig.etiqueta.top=top;
    let call=this.storageService.onObjSetted().subscribe(()=>{
      call.unsubscribe();
      this.setEtiquetaConfig.next(localConfig);
      ConfigServices.localConfig=localConfig;
    });
    this.storageService.setObject('localConfig',localConfig);
  }
}


